
import './index.less'
import React from 'react'
import { useState, useEffect } from 'react'

export default function HocCalculateDistance(props) {
  const [ifon] = useState({
    calComp: React.createRef()
  })

  useEffect(() => {
    props.compIfon.calComp = ifon.calComp.current
  }, [])

  return (<div className={`HocCalculateDistance ${props.compIfon.name === 'marketing_suspension_comp' ? 'mySuspension' : ''} ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`} ref={ifon.calComp}>
    {props.children}
    {props.isSide && <div className='HocCalculateDistance_side'>
      <div className='side_delete' onClick={() => {
        props.deleteItem && props.deleteItem(props.compIfon.id)
      }}>
        <i className='delete_icon'>
          <svg class='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' data-interactive='false' data-icon='delete-outlined'><path d='M14 5V15C14 15.5523 13.5523 16 13 16H5C4.44772 16 4 15.5523 4 15V5H2.5C2.22386 5 2 4.77614 2 4.5V4C2 3.72386 2.22386 3.5 2.5 3.5H6V2.5C6 2.22386 6.22386 2 6.5 2H11.5C11.7761 2 12 2.22386 12 2.5V3.5H15.5C15.7761 3.5 16 3.72386 16 4V4.5C16 4.77614 15.7761 5 15.5 5H14ZM5.5 5V14.5H12.5V5H5.5ZM7 6.5H8.5V13H7V6.5ZM9.5 6.5H11V13H9.5V6.5Z' fill-rule='evenodd'></path></svg>
        </i>
      </div>
    </div>}
  </div>)
}
